var cov_270g80mlp1 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/dom/isDOMElement.ts",
      hash = "1f3bcb035a676fc0e8c999c433ad2bb959a0f683",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/dom/isDOMElement.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 8,
          column: 90
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 15
          },
          end: {
            line: 5,
            column: 16
          }
        },
        loc: {
          start: {
            line: 5,
            column: 46
          },
          end: {
            line: 9,
            column: 1
          }
        },
        line: 5
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 9
          },
          end: {
            line: 8,
            column: 90
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 6
          },
          end: {
            line: 7,
            column: 31
          }
        }, {
          start: {
            line: 8,
            column: 6
          },
          end: {
            line: 8,
            column: 90
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 6
          },
          end: {
            line: 8,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 6
          },
          end: {
            line: 8,
            column: 8
          }
        }, {
          start: {
            line: 8,
            column: 12
          },
          end: {
            line: 8,
            column: 34
          }
        }, {
          start: {
            line: 8,
            column: 38
          },
          end: {
            line: 8,
            column: 55
          }
        }, {
          start: {
            line: 8,
            column: 59
          },
          end: {
            line: 8,
            column: 90
          }
        }],
        line: 8
      }
    },
    s: {
      "0": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

export default function (el) {
  cov_270g80mlp1.f[0]++;
  cov_270g80mlp1.s[0]++;
  return typeof HTMLElement === 'function' ? (cov_270g80mlp1.b[0][0]++, el instanceof HTMLElement) : (cov_270g80mlp1.b[0][1]++, (cov_270g80mlp1.b[1][0]++, el) && (cov_270g80mlp1.b[1][1]++, typeof el === 'object') && (cov_270g80mlp1.b[1][2]++, el.nodeType === 1) && (cov_270g80mlp1.b[1][3]++, typeof el.nodeName === 'string'));
}